import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../infra/http/axios-http-client";
import { RemoteEditCustomers } from "../../data/usecases/remote-edit-customers";
import Endpoints from "../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../base";
import Swal from "sweetalert2";
import { EdiitCustomerDetails } from "../../domain/models/customer-database/edit-customer-details";
import { getDataKeyFromLocalStorage } from "../../common/utils/AuthToken";

export interface EditCustomerInterface {
  editCustomer: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useEditCustomerSlice: StateCreator<EditCustomerInterface> = (
  set
) => ({
  editCustomer: async (
    id: number,
    customer_data: EdiitCustomerDetails,
    handleClose: Function,
    fetchCustomerData: Function
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteEditCustomers = new RemoteEditCustomers(
      `${BASE_URL}${Endpoints.EDIT_CUSTOMERS}`,
      axiosHttpClient
    );
    let result = await remoteEditCustomers.edit(id.toString(), customer_data);

    if (result.success) {
      handleClose();
      fetchCustomerData();
      Swal.fire({
        icon: "success",
        text: "Updated successfully",
        timer: 3000,
        customClass: {
          container: "swal2-style",
        },
      });
    } else {
      Swal.fire({
        icon: "error",
        text: "Update Failed",
        timer: 3000,
        customClass: {
          container: "swal2-style",
        },
      });
    }
  },
});
